export const Egg = ({ color }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="35px"
      height="35px"
      viewBox="0 0 135 135"
    >
      <g>
        <path
          className="st187"
          d="M115.667,81.167c0,26.601-21.564,48.166-48.166,48.166c-26.604,0-48.168-21.565-48.168-48.166
			c0-26.604,21.564-75.5,48.168-75.5C94.103,5.667,115.667,54.563,115.667,81.167z"
          fill="#FFFFFA"
        />
      </g>
      <g>
        <path
          className="st113"
          d="M67.501,5.667v123.666c26.602,0,48.166-21.565,48.166-48.166C115.667,54.563,94.103,5.667,67.501,5.667z"
          fill="#F9F9E4"
        />
      </g>
      <g>
        <g>
          <path
            className="st5"
            d="M37.653,108.493c4.445,4.857,9.34,7.236,6.738,9.617c-2.604,2.381-8.316,0.371-12.762-4.486
				c-4.443-4.858-5.936-10.728-3.332-13.109C30.899,98.136,33.21,103.632,37.653,108.493z"
            fill={color}
            stroke="#333"
            strokeWidth="1"
          />
        </g>
        <g>
          <path
            className="st78"
            d="M97.347,108.493c-4.445,4.857-9.34,7.236-6.738,9.617c2.604,2.381,8.316,0.371,12.762-4.486
				c4.443-4.858,5.936-10.728,3.332-13.109C104.101,98.136,101.79,103.632,97.347,108.493z"
            fill={color}
            stroke="#333"
            strokeWidth="1"
          />
        </g>
      </g>
      <g>
        <path
          className="st205"
          d="M67.501,130.833c-27.387,0-49.668-22.28-49.668-49.666c0-13.942,5.612-32.964,14.299-48.46
			C42.449,14.303,55.01,4.167,67.501,4.167c12.49,0,25.051,10.136,35.367,28.54c8.687,15.496,14.299,34.518,14.299,48.46
			C117.167,108.553,94.887,130.833,67.501,130.833z M67.501,7.167c-6.578,0-19.579,3.509-32.752,27.007
			c-8.454,15.081-13.916,33.526-13.916,46.993c0,25.732,20.936,46.666,46.668,46.666c25.731,0,46.666-20.934,46.666-46.666
			c0-13.466-5.462-31.912-13.916-46.993C87.079,10.676,74.078,7.167,67.501,7.167z"
          fill="#444"
        />
      </g>
      <g>
        <path
          fill={color}
          className="st5"
          stroke="#333"
          strokeWidth="1"
          d="M95.79,93.637c-6.268,13.575-19.066,21.016-28.588,16.62s-5.098-12.389,1.17-25.965
			c6.266-13.573,12.002-27.589,21.523-23.191C99.417,65.495,102.056,80.063,95.79,93.637z"
        />
      </g>
      <g>
        <path fill={color} className="st78" stroke="#333" strokeWidth="1" />
      </g>
      <g>
        <circle
          className="st5"
          cx="39.803"
          cy="42.714"
          r="3.06"
          fill={color}
          stroke="#333"
          strokeWidth="1"
        />
      </g>
      <g>
        <circle
          className="st5"
          cx="50.845"
          cy="28.077"
          r="1.197"
          fill={color}
          stroke="#333"
          strokeWidth="1"
        />
      </g>
      <g>
        <circle
          className="st5"
          cx="44.593"
          cy="60.277"
          r="1.73"
          fill={color}
          stroke="#333"
          strokeWidth="1"
        />
      </g>
      <g>
        <circle
          className="st78"
          cx="71.559"
          cy="117.383"
          r="1.729"
          fill={color}
          stroke="#333"
          strokeWidth="1"
        />
      </g>
      <g>
        <circle
          className="st5"
          cx="63.418"
          cy="115.653"
          r="1.729"
          fill={color}
          stroke="#333"
          strokeWidth="1"
        />
      </g>
      <g>
        <circle
          className="st78"
          cx="88.046"
          cy="34.144"
          r="3.537"
          fill={color}
          stroke="#333"
          strokeWidth="1"
        />
      </g>
      <g>
        <circle
          className="st78"
          cx="98.08"
          cy="49.233"
          r="3.46"
          fill={color}
          stroke="#333"
          strokeWidth="1"
        />
      </g>
      <g>
        <circle
          className="st5"
          cx="48.835"
          cy="95.614"
          r="3.459"
          fill={color}
          stroke="#333"
          strokeWidth="1"
        />
      </g>
      <g>
        <path
          className="st5"
          d="M71.226,44.859c0,8.108,3.498,14.682-4.611,14.682s-14.682-6.573-14.682-14.682s6.572-14.685,14.682-14.685
			S71.226,36.751,71.226,44.859z"
          fill={color}
          stroke="#333"
          strokeWidth="1"
        />
      </g>
      <g>
        <path
          className="st78"
          d="M67.501,59.508c6.951-0.482,3.725-6.854,3.725-14.648s3.227-14.169-3.725-14.651V59.508z"
          fill={color}
        />
      </g>
    </svg>
  );
};
